import { Settings } from '@/features/settings/settings';
import { AppLayout } from '@/layouts/app-layout';

function SettingsPage() {
  return (
    <AppLayout>
      <Settings />
    </AppLayout>
  );
}

export default SettingsPage;
